import React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { Box, Button, Divider, FormHelperText, InputLabel, OutlinedInput, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import PageHeader from '../../../components/page-header';
import { useBudgetUnitCreateEditController } from './context/budget-unit-create-edit-controller';
import { useBudgetUnitCreateEditState } from './context/budget-unit-create-edit-context';

export function BudgetUnitCreateEditComponent() {
    const { handleOnChange, handleSave, handleCancel, isSaving } = useBudgetUnitCreateEditController();
    const { budgetUnitRequest, showValidationErrors, budgetUnitId } = useBudgetUnitCreateEditState();
    const isEdit = !!budgetUnitId;

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title={isEdit ? 'Editar Unidade Orçamentária' : 'Nova Unidade Orçamentária'}
                    subtitle={isEdit ? 'Atualize as informações da unidade orçamentária' : 'Cadastre uma nova unidade orçamentária no sistema'}
                    breadcrumbs={[{ label: 'Unidades Orçamentárias', href: '/unidades-orcamentarias' }, { label: isEdit ? 'Editar' : 'Nova' }]}
                />
            </Grid>

            <Grid item xs={12}>
                <Paper sx={{ p: 3, display: 'flex', flexDirection: 'column' }} elevation={3}>
                    <Grid container spacing={3}>

                        {/* Identificação */}
                        <Grid item xs={12}>
                            <Typography variant="h6" sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}>
                                Identificação
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <InputLabel required>Exercício</InputLabel>
                            <OutlinedInput
                                fullWidth
                                autoComplete="off"
                                name="year"
                                type="number"
                                disabled={isEdit}
                                value={budgetUnitRequest.year || ''}
                                onChange={handleOnChange}
                                error={showValidationErrors && !budgetUnitRequest.year}
                            />
                            {showValidationErrors && !budgetUnitRequest.year && (
                                <FormHelperText error>Exercício é obrigatório</FormHelperText>
                            )}
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <InputLabel required>Código</InputLabel>
                            <OutlinedInput
                                fullWidth
                                autoComplete="off"
                                name="code"
                                value={budgetUnitRequest.code || ''}
                                onChange={handleOnChange}
                                error={showValidationErrors && !budgetUnitRequest.code}
                            />
                            {showValidationErrors && !budgetUnitRequest.code && (
                                <FormHelperText error>Código é obrigatório</FormHelperText>
                            )}
                        </Grid>

                        <Grid item xs={12} md={7}>
                            <InputLabel required>Nome</InputLabel>
                            <OutlinedInput
                                fullWidth
                                autoComplete="off"
                                name="name"
                                value={budgetUnitRequest.name || ''}
                                onChange={handleOnChange}
                                error={showValidationErrors && !budgetUnitRequest.name}
                            />
                            {showValidationErrors && !budgetUnitRequest.name && (
                                <FormHelperText error>Nome é obrigatório</FormHelperText>
                            )}
                        </Grid>

                        {/* Ações */}
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, mt: 2, borderTop: '1px solid', borderColor: 'divider' }}>
                                <Box sx={{ flex: '1 1 auto' }} />
                                <Button
                                    variant="outlined"
                                    startIcon={<CancelIcon />}
                                    onClick={handleCancel}
                                    sx={{ mr: 1 }}
                                >
                                    Cancelar
                                </Button>
                                <LoadingButton
                                    variant="contained"
                                    startIcon={<SaveIcon />}
                                    onClick={handleSave}
                                    loading={isSaving}
                                    disabled={isSaving}
                                >
                                    Salvar
                                </LoadingButton>
                            </Box>
                        </Grid>

                    </Grid>
                </Paper>
            </Grid>
        </React.Fragment>
    );
}
